import { memo } from 'react'
import { useMountEffect } from 'hooks/useMountEffect'
import { connect } from 'react-redux'
import StoreState, { StoreThunkDispatch } from 'store/state'
import { allFilesFolderSelector } from 'services/uploads/selectors'
import { getUploads } from 'services/uploads/actions'
import { FileFolder } from 'interfaces'
import { useIntl } from 'react-intl'
import { ConnectedFileFolderCarousel } from 'routes/find/routes/my-uploads/components/FileFolderCarousel'
import { SECTION_URL_MY_LIBRARY } from '../../home.config'

interface RecentUploadsCarouselProps {
  folder: FileFolder
  title?: string
  fetchUploads: () => Promise<any>
}

const RecentUploadsCarousel = memo(function (props: RecentUploadsCarouselProps) {
  const intl = useIntl()
  useMountEffect(() => {
    props.fetchUploads()
  })

  const folder = {
    ...props.folder,
    name: props.title || intl.formatMessage({ id: `find.home.sections.my-library` })
  }

  return (
    <ConnectedFileFolderCarousel
      folder={folder}
      withEmptyViewCTA
      withCTACard
      navPrefix={SECTION_URL_MY_LIBRARY}
    />
  )
})

function mapStateToProps(state: StoreState) {
  return {
    folder: allFilesFolderSelector(state)
  }
}

function mapDispatchToProps(dispatch: StoreThunkDispatch) {
  return {
    fetchUploads: () => dispatch(getUploads()).unwrap()
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecentUploadsCarousel)
